export enum TriggerType {
  PROMPT_CHANGE = 'prompt_change',
  QUERY = 'query',
  MANUAL = 'manual',
}

export interface EvaluationInput {
  question?: string;
  response?: string;
  context?: string[];
  ground_truth?: string;
}

export interface Evaluation {
  id: string;
  score: number;
  human_scores: number | null;
  critique: string | null;
  reason?: string;
  trigger_type: string;
  trigger_id?: string;
  name: string;
  input: EvaluationInput;
  trace_id?: string;
  trace_url?: string;
}

export interface EvaluationFilters {
  trigger_type?: string;
  trigger_id?: string;
}

export interface EvaluationGroup {
  trace_id: string;
  evaluations: Evaluation[];
}

export interface PaginatedResponse {
  data: EvaluationGroup[];
  pagination: {
    total: number;
    page: number;
    limit: number;
  };
}

export interface EvaluationState {
  groups: EvaluationGroup[];
  loading: boolean;
  error: string | null;
  total: number;
}
